<div class="d-flex align-items-center">
  <span class="fw-bold uppercase font-3 me-2 mt-2px"
    >Download Ordered Items</span
  >
  <button
    class="btn btn-icon large with-border with-shadow background-white me-3"
    title="Export to Excel"
    (click)="exportToExcel()"
  >
    <i class="fal fa-file-excel"></i>
  </button>
  <button
    class="btn btn-icon large with-border with-shadow background-white"
    title="Export to PDF"
    (click)="exportToPDF()"
  >
    <i class="fal fa-file-pdf"></i>
  </button>
</div>
